import { Inject, Injectable } from '@angular/core';

import { ConfigurationModels } from '../../../../models/configuration.models';

import { CommonModels } from '../../../../models/common.models';
import { WAZARIAPP_TOKEN } from '../wz-core/wz-core-injection-tokens';

import * as configData from 'configurations/config.local.json';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  constructor(
    private config: ConfigurationModels.Configuration,
    @Inject(WAZARIAPP_TOKEN) private wazariApp: CommonModels.TunnelSanteAppEnum,
  ) {}

  init(): Promise<ConfigurationModels.Configuration> {
    return new Promise((resolve, reject) => {
      let configDataAny: any = configData;
      const response = configDataAny['default'];

      Object.assign(this.config, response);
      this.initAtRuntime(this.config, this.wazariApp);
      resolve(this.config);

      // //   xhr.addEventListener('readystatechange', () => {
      // //     if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
      // //       const response = JSON.parse(xhr.responseText);
      // //       // from file
      // //       Object.assign(this.config, response);
      // //       // from runtime
      // //       this.initAtRuntime(this.config, this.wazariApp);

      // //       resolve(this.config);
      // //     } else if (xhr.readyState === XMLHttpRequest.DONE) {
      // //       reject();
      // //     }
      // //   });

      // //   xhr.send(null);
    });
  }

  private initAtRuntime(
    configuration: ConfigurationModels.Configuration,
    wazariApp: CommonModels.TunnelSanteAppEnum,
  ) {
    // configuration.toasterConfig.iconClasses = {
    //   error: 'wz-error',
    //   info: 'wz-info',
    //   success: 'wz-check',
    //   warning: 'wz-warning',
    // };
    switch (wazariApp) {
      case CommonModels.TunnelSanteAppEnum.Broker:
        configuration.appInsights.instrumentationKey =
          configuration.appInsights.brokerKey;
        break;
      case CommonModels.TunnelSanteAppEnum.Backoffice:
        configuration.appInsights.instrumentationKey =
          configuration.appInsights.backOfficeKey;
        break;
      case CommonModels.TunnelSanteAppEnum.Client:
        configuration.appInsights.instrumentationKey =
          configuration.appInsights.clientKey;
    }
  }
}
